import facebookIcon from '@/assets/icons/social/fb.svg';
import twitterIcon from '@/assets/icons/social/twitter.svg';
import listIcon from '@/assets/icons/list-select-dark/list-select-dark.svg';
import exchangeIcon from '@/assets/icons/exchange/exchange.svg';
import contestIcon from '@/assets/icons/contest/contest.svg';
import { AccountTargetSupportedSocialMedia } from '@/types/account-targert-supported-social-media/account-targert-supported-social-media';


const ICON_SOURCE = {
    FACEBOOK: facebookIcon,
    TWITTER: twitterIcon,
    SURVEY: listIcon,
    EXCHANGE: exchangeIcon,
    CONTEST: contestIcon,
} as const;

export type SocialMediaType = 'Social' | 'Survey' | 'Exchange' | 'Contest' | 'Unknown';

export interface SocialMediaInfo {
    type: SocialMediaType;
    icon: string;
}

export const getIdSocialMediaType = (
    platformCode: string,
    socialMedia: AccountTargetSupportedSocialMedia[]
): SocialMediaInfo => {
    if (!platformCode) return { type: 'Unknown', icon: 'Unknown' };

    const id = platformCode.split('SM_')[1];
    if (!id) return { type: 'Unknown', icon: 'Unknown' };

    const socialEntry = socialMedia.find((social) => social?.id === Number(id));
    if (!socialEntry?.name) return { type: 'Unknown', icon: 'Unknown' };

    const icon = ICON_SOURCE[socialEntry.name.toUpperCase() as keyof typeof ICON_SOURCE];
    return { 
        type: 'Social', 
        icon: icon ?? 'Unknown' 
    };
};

export const getSocialMediaType = (
    objective: { type?: string },
    socialMedia: AccountTargetSupportedSocialMedia[]
): SocialMediaInfo => {
    if (!objective?.type) return { type: 'Unknown', icon: 'Unknown' };

    const [, platformCode] = objective.type.split(':');

    if (platformCode?.startsWith('SV_')) return { type: 'Survey', icon: ICON_SOURCE.SURVEY };
    if (objective.type.includes('EXCHANGE')) return { type: 'Exchange', icon: ICON_SOURCE.EXCHANGE };
    if (objective.type.includes('CONTEST')) return { type: 'Contest', icon: ICON_SOURCE.CONTEST };
    if (objective.type.includes('SM_')) return getIdSocialMediaType(platformCode, socialMedia);

    return { type: 'Unknown', icon: 'Unknown' };
};

export const getMissionTypeFromObjectives = (
    objectives: { type?: string }[],
    socialMedia: AccountTargetSupportedSocialMedia[]
): SocialMediaInfo => {
    if (!objectives?.length) return { type: 'Unknown', icon: 'Unknown' };

    const contestObjective = objectives.find(obj => obj.type?.includes('CONTEST'));
    if (contestObjective) return { type: 'Contest', icon: ICON_SOURCE.CONTEST };

    const exchangeObjective = objectives.find(obj => obj.type?.includes('EXCHANGE'));
    if (exchangeObjective) return { type: 'Exchange', icon: ICON_SOURCE.EXCHANGE };

    for (const objective of objectives) {
        if (!objective.type) continue;

        const [, platformCode] = objective.type.split(':');
        
        if (platformCode?.startsWith('SV_')) return { type: 'Survey', icon: ICON_SOURCE.SURVEY };
        if (platformCode?.includes('SM_')) return getIdSocialMediaType(platformCode, socialMedia);
    }

    return { type: 'Unknown', icon: 'Unknown' };
};
